<template>
<div class="mb-3">
  <div class="table-caption">{{ tableCaption }}</div>
  <VuePerfectScrollbar class="objetives-table-holder" >
  <b-table responsive stacked="sm" :fields="fields" :items="items" :per-page="perPage" :current-page="currentPage">
    <template slot="name" slot-scope="data">
      <i :class="'fa fa-thumbs-up text-'+data.item.variant" v-if="data.item.variant == 'success'"></i>
      <i :class="'fa fa-thumbs-down text-'+data.item.variant" v-if="data.item.variant != 'success'"></i> {{ data.item.name }}
    </template>
    <template  v-slot:cell(objective_value)="data">
      {{ Math.round(data.item.objective_value) | currency({fractionCount:0, symbol:symbol}) }}
    </template>
    <template v-slot:cell(current)="data">
      {{ Math.round(data.item.current) | currency({fractionCount:0, symbol:symbol}) }}
    </template>
    <template v-slot:cell(progress)="data">
      {{ data.item.progress | currency({fractionCount:1, symbol:'%'}) }}
    </template>
    <template v-slot:cell(remaining)="data">
      {{ data.item.remaining | currency({fractionCount:0, symbol:''}) }}
    </template>
    <template v-slot:cell(balance)="data">
      {{  Math.round(data.item.current - data.item.objective_value) | currency({fractionCount:0, symbol:''}) }}
    </template>
  </b-table>
  </VuePerfectScrollbar>
  <b-pagination v-show="items.length>perPage && perPage>0" :total-rows="items.length" :per-page="perPage" v-model="currentPage" class="justify-content-center" />
</div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  props: ['items', 'fields', 'table-caption', 'symbol', 'per-page', 'show-remaining'],
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      currentPage: 1
    }
  },
  methods: {},
  created() {
    console.log('Remaining:', this.showRemaining)
  }
}
</script>



// WEBPACK FOOTER //
// ObjectivesTable.vue?78e2a1eb